import { render } from "./MainlandAccessNotice.vue?vue&type=template&id=2b939450&scoped=true"
import script from "./MainlandAccessNotice.vue?vue&type=script&lang=js"
export * from "./MainlandAccessNotice.vue?vue&type=script&lang=js"

import "./MainlandAccessNotice.vue?vue&type=style&index=0&id=2b939450&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b939450"]])

export default __exports__